import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReferencedTables } from '@app/enums';

@Injectable()
export class NotesService {
	endpointBase = '/api/notes';

	constructor(private readonly http: HttpClient) {}

	getListForEntity(referenceTableId: ReferencedTables, entityId: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/${referenceTableId}/${entityId}`);
	}

	createEntity(referenceTableId: ReferencedTables, entityId: number, noteText: string): Observable<any> {
		return this.http.post(`${this.endpointBase}/${referenceTableId}/${entityId}`, { noteText });
	}

	updateEntity(id: number, noteText: string): Observable<any> {
		return this.http.put(`${this.endpointBase}/${id}`, { noteText });
	}

	deleteEntity(id: number): Observable<any> {
		return this.http.delete(`${this.endpointBase}/${id}`);
	}
}
